import { MamapediaCategoryItem } from "@/lib/constants";
import Link from "next/link";
import Image from 'next/image';


interface CategoryListItemProps {
  categories: Array<MamapediaCategoryItem>;
}

const MamapediaMobileMenuItem = (props: CategoryListItemProps) => {
  const { categories } = props;

  return (
    <div className="w-[90%] overflow-y-auto mega-menu-height font-poppins text-mobileMenu">
      <div className="container">
        {categories.map((category, index) => {
          return (
            category.subcategory.length > 0 && (
              <div key={index}>
                <div className="mb-6">
                  <Link href={category.url}>
                    <p className="text-black text-lg font-bold">{category.name}</p>
                  </Link>
                </div>
                {category.subcategory.map((subItem, index2) => (
                  <div key={index2} className={index2 > 0 ? "mt-8" : ""}>
                    <Link href={`/latest-mamapedia/${subItem.slug}?category=${category.slug}`}>
                      <div className="w-full flex space-x-3 items-center">
                        {subItem.mobile_image !== null && subItem.mobile_image !== undefined && (
                          <Image
                            src={subItem.mobile_image}
                            alt={subItem.name}
                            width={32}
                            height={32}
                            quality={100}
                            className="rounded-full"
                          />
                        )}
                        <p className={`text-black text-sm font-poppins text-center`}>{subItem.name}</p>
                      </div>
                    </Link>
                  </div>
                ))}
                {index < categories.length - 1 && (<hr className="bg-reviewBg my-4" />)}
              </div>
            )
          )
        })}
      </div>
    </div>
  )
}

export default MamapediaMobileMenuItem
